module.exports = __webpack_public_path__ + "static/03-2f9c85f04909d67a1545508949854c35.png";